import React, { useState } from "react";

const RejectPopup = ({
  setActiveRejectRow,
  action,
  id,
  handleApproval,
}) => {
  const [localReason, setLocalReason] = useState("");

  return (
    <div>
      {
        <div className="fixed inset-0 bg-transparent bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h2 className="text-lg font-semibold mb-4">Reason for Rejection</h2>
            <textarea
              className="w-full border border-gray-300 rounded p-2 mb-4"
              rows={3}
              value={localReason}
              onChange={(e) => setLocalReason(e.target.value)}
              placeholder="Enter reason..."
            />
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => {
                  setActiveRejectRow(false);
                }}
                className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setActiveRejectRow(false);
                  handleApproval(id, action, localReason);
                }}
                className="px-3 py-1 bg-primary text-white rounded hover:bg-green-600"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default RejectPopup;
